import {LitElement, html, css} from 'lit-element';
import jsQR from 'jsqr';
// import qrcode from '@lostinbrittany/jsqrcode';

class ScannerQrComponent extends LitElement {
    static get properties() {
        return {
            data: {
              type: String,
              notify: true
            },
            disabled: {
              type: Boolean
            },
            stream: {
              type: Object,
            }
        };
    }

    static get styles() {
        return [
          css`
          :host {
            display: block;
          }
          #myCanvas{
            background-color:lime;
            filter:brightness(200%);
            filter: contrast(5%);
            filter: grayscale(1);
          }
          [hide] {
            display: none !important;
          }
          #myVideo{
            position: fixed;
            top: 50%;
            left: 50%;
            min-width: 100%;
            min-height: 100%;
            width: auto;
            height: auto;
            z-index: -100;
            transform: translateX(-50%) translateY(-50%);
          }
          .box {
            position: absolute;
            top: 0;
            left: 50%;
            min-width: 320px;
            width: 70%;
            height: 50%;
            transform: translate(-50%, 45%);
          }
          .box::before, .box::after {
            position: absolute;
            width: 10%;
            height: 15%;
            border-color: white;
            border-style: solid;
            content: ' ';
          }

          .scanner-top::before {
            top: 0;
            left: 0;
            border-width: 5px 0 0 5px;
          }

          .scanner-top::after {
            top: 0;
            right: 0;
            border-width: 5px 5px 0 0;
          }

          .scanner-bottom::before {
            bottom: 0;
            right: 0;
            border-width: 0 5px 5px 0;
          }

          .scanner-bottom::after {
            bottom: 0;
            left: 0;
            border-width: 0 0 5px 5px;
          }

          .box .scanner {
            display: none;
            width: 95%;
            height: 3px;
            background-color: red;
            opacity: 0.7;
            position: relative;
            box-shadow: 0px 0px 6px 8px rgba(170, 11, 23, 0.49);
            top: 50%;
            margin: 0 auto;
            animation-name: scan;
            animation-duration: 4s;
            animation-timing-function: linear;
          }

          @keyframes scan {
            0% {
              box-shadow: 0px 0px 6px 8px rgba(170, 11, 23, 0.49);
              top: 50%;
            }  
            25% {
              box-shadow: 0px 4px 6px 8px rgba(170, 11, 23, 0.49);
              top: 5px;
            }
            75% {
              box-shadow: 0px -4px 6px 8px rgba(170, 11, 23, 0.49);
              top: 98%;
            }
          }
          `,
        ];
      }

    render() {
        return html`
        <div class="box scanner-top"> 
            <div class="scanner"></div>
        </div>
        <div class="box scanner-bottom"></div>
        <video id="myVideo" width="320" height="240" autoplay muted></video>
        <canvas id="myCanvas" hide></canvas>`;
    }

    updated(changedProperties) {
      if (changedProperties.has('disabled')) {
        this.disconnect();
      }
    }
    
    connectedCallback(){
      super.connectedCallback();
      this.getMedia();
    }

    async getMedia() {
      const optionsVideo = {
        width: { min: 360, ideal: 640, max: 1920 },
        height: { min: 240, ideal: 480, max: 1080 },
        facingMode: 'environment'
      };
      await navigator.mediaDevices.getUserMedia({ audio: false, video: optionsVideo })
        .then((stream) => {
          this.stream = stream;
          let video = this.shadowRoot.querySelector('#myVideo');
          if (video.srcObject !== undefined) {
            video.srcObject = stream;
          } else if (video.mozSrcObject !== undefined) {
            video.mozSrcObject = stream;
          } else if (window.URL.createObjectURL) {
            video.src = window.URL.createObjectURL(stream);
          } else if (window.webkitURL) {
            video.src = window.webkitURL.createObjectURL(stream);
          } else {
            video.src = stream;
          }
          video.setAttribute("playsinline", true);
          video.play();
          this._startScan();
        });
    }

    _startScan(){
      this.scan = setInterval(() => { 
        this._scan();
      }, 4000);     
    }

    _scan() {
      const video = this.shadowRoot.querySelector('#myVideo');
      const canvas = this.shadowRoot.querySelector('#myCanvas');
      const context = canvas.getContext("2d");

      if (video.readyState === video.HAVE_ENOUGH_DATA) {
        canvas.height  = video.videoHeight;
        canvas.width   = video.videoWidth;
        context.drawImage(video, 0, 0, canvas.width, canvas.height);
        const scanner = this.shadowRoot.querySelector('.scanner');
        const imageData = context.getImageData(0, 0, canvas.width, canvas.height);
        try {
          scanner.style.display = 'block';
          const code = jsQR(imageData.data, imageData.width, imageData.height);

          if (code) {
            this.data = code.data
            this.dispatchEvent(new CustomEvent('qrcode-decoded', { detail: this.data }));
          } else {
            scanner.style.display = 'none';
          }
          // qrcode.decodeWithCallback(this._result.bind(this), '', canvas);
        } catch(e) {
          console.error(e, 'scanning error')
          scanner.style.display = 'none';
        }
      }
    }

    /* _result(result){
      this.data = result;
      this.dispatchEvent(new CustomEvent('qrcode-decoded', { detail: this.data }));
      const scanner = this.shadowRoot.querySelector('.scanner');
      setTimeout(() => {
        scanner.style.display = 'none';
      }, 2000);
    } */

    disconnect(){
      this.stream.getVideoTracks().forEach(track => {
        track.stop();
      });
    }
}

  window.customElements.define('scanner-qr-component', ScannerQrComponent);